import { Link } from "react-router-dom";
import { Phone, ArrowUpRight } from "lucide-react";
import { WhatsAppIcon } from "./Icons";
import { DiscountBadge } from "./ServiceCard";
import { useSite } from "../../context/SiteContext";
import { TEL, WA, PHONE_DISPLAY } from "../../lib/site";

const LINKS = [
  { to: "/sivas-masaj-salonu", label: "Sivas Masaj Salonu" },
  { to: "/sivas-masaj", label: "Sivas Masaj" },
  { to: "/sivas-spa", label: "Sivas Spa" },
  { to: "/sivas-spa-merkezi", label: "Sivas Spa Merkezi" },
  { to: "/masaj-hizmetleri", label: "Masaj Hizmetleri" },
  { to: "/iletisim", label: "İletişim" },
];

export const AsideCta = ({ current, waHref = WA, extra }) => {
  const { settings } = useSite();
  return (
    <aside className="space-y-6 lg:sticky lg:top-28" data-testid="aside-cta">
      <div className="bg-emerald-grad relative overflow-hidden rounded-3xl p-7 text-white">
        <div className="pointer-events-none absolute -right-10 -top-10 h-36 w-36 rounded-full border border-gold/25" />
        <DiscountBadge />
        {settings.campaign_active && <p className="mt-4 text-sm text-white/75">{settings.campaign_text}</p>}
        <p className="mt-5 text-xl font-semibold">Randevunuzu hemen oluşturun</p>
        {extra}
        <div className="mt-6 flex flex-col gap-3">
          <a href={waHref} target="_blank" rel="noopener noreferrer" className="btn-gold" data-testid="aside-whatsapp-btn">
            <WhatsAppIcon className="h-4 w-4" /> WhatsApp’tan Randevu Al
          </a>
          <a href={TEL} className="btn-ghost-light" data-testid="aside-call-btn">
            <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
          </a>
        </div>
      </div>
      <div className="card-lux p-6">
        <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-gold-deep">Keşfedin</p>
        <ul className="divide-y divide-gold/15">
          {LINKS.filter((l) => l.to !== current).map((l) => (
            <li key={l.to}>
              <Link to={l.to} className="group flex items-center justify-between py-3 text-sm font-medium text-emerald-950 transition-colors hover:text-gold-deep">
                {l.label}
                <ArrowUpRight className="h-4 w-4 text-gold transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};
